import Keycloak from 'keycloak-js';

// Configure Keycloak instance
const keycloak = new Keycloak({
    url: 'https://sso.compuzz.com',
    realm: 'master',
    clientId: 'compuzz-joseline-bot',
});

// Enable token persistence
keycloak.onTokenExpired = () => {
    console.log('Token expired, refreshing...');
    keycloak.updateToken(30).then((refreshed) => {
        if (refreshed) {
            console.log('Token refreshed via onTokenExpired');
            // Update stored tokens
            sessionStorage.setItem('kc_token', keycloak.token);
            sessionStorage.setItem('kc_refreshToken', keycloak.refreshToken);
        }
    }).catch(() => {
        console.error('Failed to refresh token via onTokenExpired');
        // If token refresh fails, redirect to login
        keycloak.login();
    });
};

// Store tokens when authentication is successful
keycloak.onAuthSuccess = () => {
    console.log('Authentication successful, storing tokens');
    sessionStorage.setItem('kc_token', keycloak.token);
    sessionStorage.setItem('kc_refreshToken', keycloak.refreshToken);
};

// Clear tokens when user logs out
keycloak.onAuthLogout = () => {
    console.log('User logged out, clearing tokens');
    sessionStorage.removeItem('kc_token');
    sessionStorage.removeItem('kc_refreshToken');
};

// Handle authentication errors
keycloak.onAuthError = (error) => {
    console.error('Authentication error', error);
    // Clear any stored tokens
    sessionStorage.removeItem('kc_token');
    sessionStorage.removeItem('kc_refreshToken');
    // Redirect to login
    keycloak.login();
};

export default keycloak;
